<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>جستجو</label>
                        <input type="text" class="form-control" v-model="searchInput" @keyup="search">
                    </div>
                </div>
            </div>
            <div class="table-responsive" v-if="people.length">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>نام</th>
                            <th>نام خانوادگی</th>
                            <th>پن</th>
                            <th>شماره همراه</th>
                            <th>شماره پاسپورت</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(person,index) in people" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ person.firstName }}</td>
                            <td>{{ person.lastName }}</td>
                            <td class="text-left">{{ person.pan }}</td>
                            <td class="text-left">{{ person.mobile }}</td>
                            <td class="text-left">{{ person.passportNo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">شخصی یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tourists',
    data(){
        return {
            allPeople: [],
            people: [],
            searchInput: '',
            showLoading: true,
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Tourists').then(({data}) => {
                if(data.status){
                    this.allPeople = data.result;
                    this.people = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        search(){
            this.people = this.allPeople.filter(person => (person.firstName + ' ' + person.lastName).includes(this.searchInput) || person.pan.includes(this.searchInput) || person.mobile.includes(this.searchInput) || person.passportNo.includes(this.searchInput));
        }
    },
    created(){
        this.getData();
    }
}
</script>